<template>
    <div
        class="template-filters-container"
        :class="[ showSearchBar ? 'filter-style-spread' : 'filter-style-center' ]"
    >
        <DsInputField
            v-if="showSearchBar"
            class="search-input"
            data-qa="template-search-input"
            :label="$t('unlayerBuilder.templateSelection.savedTemplates.searchInputLabel')"
            :value="searchTerm"
            @input="handleSearchTermUpdate"
        >
            <template #leading>
                <DsIcon name="search" />
            </template>
        </DsInputField>

        <div v-if="showEmailTypeDropdown" class="email-type-container">
            <span class="email-type-label">
                {{ $t('unlayerBuilder.templateSelection.filterBy') }}
            </span>

            <DsMultiselect
                bind-value-only
                :value="filterEmailType"
                :options="typeOptions"
                :placeholder="$t('unlayerBuilder.templateSelection.savedTemplates.filterEmailTypePlaceholder')"
                class="filter-select"
                data-qa="template-email-type-filter"
                @input="handleFilterEmailTypeUpdate"
            />
        </div>
    </div>
</template>

<script>
import debounce from 'lodash.debounce';

import { AGGREGATED_EMAIL_TEMPLATES_FILTER_OPTIONS as FILTER_OPTIONS } from '@/components/broadcast/constants/emailBroadcast.constants';
import { INPUT_DEBOUNCE_DELAY } from '@/components/shared/constants/timing.constants';

export default {
    props: {
        filterEmailType: {
            type: String,
            default: FILTER_OPTIONS.ALL,
        },
        searchTerm: String,
        showEmailTypeDropdown: Boolean,
        showSearchBar: Boolean,
    },

    created() {
        this.handleSearchTermUpdate = debounce(this.handleSearchTermUpdate, INPUT_DEBOUNCE_DELAY);
    },

    computed: {
        typeOptions() {
            return [{
                value: FILTER_OPTIONS.ALL,
                label: this.$t('unlayerBuilder.templateSelection.savedTemplates.typeOptions.all'),
            }, {
                value: FILTER_OPTIONS.BARD,
                label: this.$t('unlayerBuilder.templateSelection.savedTemplates.typeOptions.legacyTemplates'),
            }, {
                value: FILTER_OPTIONS.UNLAYER,
                label: this.$t('unlayerBuilder.templateSelection.savedTemplates.typeOptions.templates'),
            }];
        },
    },

    methods: {
        handleFilterEmailTypeUpdate(value) {
            this.$emit('update:filterEmailType', value);
        },

        handleSearchTermUpdate(value) {
            this.$emit('update:searchTerm', value);
        }
    },
};
</script>

<style lang="scss" scoped>
.template-filters-container {
    display: flex;
}

.filter-style-spread {
    justify-content: space-between;
}

.filter-style-center {
    justify-content: center;
}

.search-input {
    width: px-to-rem(350);
    --input-margin-bottom: 0;
}

.email-type-label {
    color: $color-ink;
    width: fit-content;
}

.email-type-container {
    display: flex;
    align-items: center;
    gap: $spacing-200;
}

.filter-select {
    width: px-to-rem(300);
    margin-bottom: 0;
}
</style>
